module.exports = __webpack_public_path__ + "img/img_badge-g.527062df.svg";